import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import BlueButton from '../../../components/BlueButton';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CalendarIcon } from '../../../assets/icons';

const NoAppointments = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <img src={CalendarIcon} alt="calendar-icon" />
      <Typography variant="h2">Não há nada para ver por aqui!</Typography>
      <Typography>
        Você não realizou nenhum agendamento até o momento.
      </Typography>
      <Box width="100%" marginTop={6} textAlign="center">
        <BlueButton dataCy="new-appointment-button" href="/novo-agendamento">
          Novo Agendamento
        </BlueButton>
      </Box>
    </Box>
  );
};

export default NoAppointments;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.up('md')]: {
        minHeight: '40vh',
      },

      '& h2': {
        width: '65vw',
        marginTop: theme.spacing(2),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center',
      },

      '& p': {
        marginTop: theme.spacing(1),
        width: '70%',
        color: theme.palette.text.secondary,
        textAlign: 'center',
      },
    },
  })
);
